import React, { useEffect, useState } from "react";
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    Tooltip,
    CartesianGrid,
    ResponsiveContainer,
} from "recharts";
import Swal from "sweetalert2";
import apiSafibc from "../../axios/axios";

const GraficasEncuesta = () => {

    /*const data = {
        questions: [
            {
                id: 1,
                title: "¿Qué tan satisfecho estás con el servicio?",
                responses: [10, 9, 8, 6, 10, 7, 8, 5, 4, 3, 1, 10], // valores de 1 a 10
            },
            {
                id: 2,
                title: "¿Recomendarías este producto a otros?",
                responses: [8, 8, 7, 9, 6, 10, 10, 9, 10],
            },
            {
                id: 3,
                title: "¿Qué tan fácil fue usar la plataforma?",
                responses: [9, 10, 9, 9, 8, 8, 9, 10],
            },
        ],
        observations: [
            "Me gustaría que el tiempo de respuesta fuera más rápido.",
            "La interfaz podría ser más amigable.",
            "Excelente atención al cliente.",
            "Tardó mucho en cargar la página.",
            "Muy satisfecho, sigan así.",
            "No encontré el botón de ayuda.",
            "El diseño es muy limpio y claro.",
            "Faltan más opciones de personalización.",
        ],
    };*/

    const [data, setData] = useState(null)
    const [paginatedObservations, setPaginatedObservations] = useState(null)
    const [totalPages, setTotalPages] = useState(null)

    const consultarInfoEncuestas = () => {

        const infoEncuestas = async () => {

            try {

                const info = await apiSafibc.get('/encuesta/info-encuestas', {
                    headers: {
                        'XP1-K3Y': `S4f1Vc`,
                        'Accept': 'application/x-www-form-urlencoded',
                        'Content-Type': 'application/x-www-form-urlencoded',
                    }
                })
                console.log(info)
                setData(info.data)


                const pagObs = info.data.observations.slice(
                    currentPage * observationsPerPage,
                    (currentPage + 1) * observationsPerPage
                )

                const tPages = Math.ceil(info.data.observations.length / observationsPerPage)


                setPaginatedObservations(pagObs)
                setTotalPages(tPages)

            } catch (error) {
                Swal.fire({
                    icon: 'error',
                    title: 'Error de información',
                    text: 'Error en obtener información para graficos'
                })
            }

        }

        infoEncuestas()

    }


    useEffect(() => {
        consultarInfoEncuestas()
    }, [])


    const [currentPage, setCurrentPage] = useState(0);
    const observationsPerPage = 4;

    // Función para contar porcentajes
    const getChartData = (responses) => {
        const total = responses.length;
        const counts = Array.from({ length: 10 }, (_, i) => ({
            name: (i + 1).toString(),
            value:
                Math.round(
                    (responses.filter((r) => r === i + 1).length / total) * 100
                ) || 0,
        }));
        return counts;
    };

    // Observaciones paginadas
    /*const paginatedObservations = data.observations.slice(
        currentPage * observationsPerPage,
        (currentPage + 1) * observationsPerPage
    );*/

    /*const totalPages = Math.ceil(data.observations.length / observationsPerPage);*/

    return (
        <div className="survey-container">
            <h1>Resultados de la Encuesta</h1>

            <div className="charts-container">
                {data && data.questions.map((q) => (
                    <div key={q.id} className="chart-card">
                        <h3>{q.title}</h3>
                        <ResponsiveContainer width="100%" height={250}>
                            <BarChart data={getChartData(q.responses)}>
                                <CartesianGrid strokeDasharray="3 3" />
                                <XAxis dataKey="name" />
                                <YAxis unit="%" />
                                <Tooltip formatter={(value) => `${value}%`} />
                                <Bar dataKey="value" fill="#0088FE" />
                            </BarChart>
                        </ResponsiveContainer>
                    </div>
                ))}
            </div>

            <div className="observations-section">
                <h2>Observaciones</h2>
                <div className="observations-cards">
                    {paginatedObservations && paginatedObservations.map((obs, index) => (
                        <div key={index} className="observation-card">
                            <p>{obs}</p>
                        </div>
                    ))}
                </div>
                <div className="pagination">
                    <button
                        disabled={currentPage === 0}
                        onClick={() => setCurrentPage(currentPage - 1)}
                    >
                        Anterior
                    </button>
                    <span>
                        Página {currentPage + 1} de {totalPages}
                    </span>
                    <button
                        disabled={currentPage >= totalPages - 1}
                        onClick={() => setCurrentPage(currentPage + 1)}
                    >
                        Siguiente
                    </button>
                </div>
            </div>

            <div className="logo-container">
                <img src="/img/logosafibc.png" alt="Logo de la empresa" />
            </div>

            {/* Estilos CSS */}
            <style>{`
            .logo-container {
            margin-top: 30px;
            text-align: center;
          }
          .logo-container img {
            max-height: 50px;
            opacity: 0.8;
          }
        .survey-container {
          max-width: 1200px;
          margin: 0 auto;
          padding: 2rem;
          font-family: Arial, sans-serif;
        }

        h1 {
          text-align: center;
          margin-bottom: 2rem;
        }

        .charts-container {
          display: flex;
          flex-wrap: wrap;
          gap: 2rem;
          justify-content: center;
        }

        .chart-card {
          background: #fff;
          padding: 1rem;
          border-radius: 10px;
          box-shadow: 0 2px 8px rgba(0,0,0,0.1);
          width: 100%;
          max-width: 350px;
        }

        .observations-section {
          margin-top: 3rem;
        }

        .observations-cards {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
          gap: 1rem;
          margin-top: 1rem;
        }

        .observation-card {
          background: #f9f9f9;
          padding: 1rem;
          border-left: 5px solid #0088FE;
          border-radius: 5px;
          box-shadow: 0 2px 4px rgba(0,0,0,0.05);
        }

        .pagination {
          margin-top: 1.5rem;
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 1rem;
        }

        .pagination button {
          padding: 0.5rem 1rem;
          background: #0088FE;
          color: white;
          border: none;
          border-radius: 5px;
          cursor: pointer;
        }

        .pagination button:disabled {
          background: #ccc;
          cursor: not-allowed;
        }
      `}</style>
        </div>
    );
};

export default GraficasEncuesta;
